import * as React from 'react';
import { MergeUserButtonProps } from 'app/area/administration/shared/merge-user/types';

export const MergeUserButton = (props: MergeUserButtonProps) => {
  const { id, name, personId, mergeUser, translation, updateMergeUser } = props;

  const handleMergeCodeItem = () => {
    updateMergeUser({
      id, name, personId, fetching: mergeUser?.fetching, showMergeUser: !mergeUser?.showMergeUser
    });
  };

  return <button
    type="button"
    className="dropdown-item"
    onClick={handleMergeCodeItem}>
    {translation.delete_item}
  </button>;
};
